import { ButtonArrowState, SecondaryButton, Title, } from '@huggg/react-components'

import { OptionCard } from "./OptionCard";
import React from 'react';
import styles from './guided-choice.module.scss';

export const GuidedChoiceQuestion = props => {
    const { title, isDefault, options, onOptionClick, onBackClick, style } = props;

    return <div className={styles.layout}>
        <Title className={styles.title}>{title}</Title>

        <div className={styles.optionsList}>
            {options.map((option, i) => {
                if (!!option.targetId) {
                    return <OptionCard data-test-id={`option-card-${i}`} key={i} optionStyle={style} imgSrc={option.imgSrc} label={option.label} onClick={() => onOptionClick(option.targetId)} />
                } else if (!!option.externalLink) {
                    return <a key={i} href={option.externalLink}>{option.label}</a>
                }
                return null;
            })}
        </div>

        {!isDefault && <SecondaryButton
            label='Go back'
            arrow={ButtonArrowState.Backwards}
            onClick={onBackClick}
        />}
    </div>
}